import { lighten } from 'polished';
import styled from 'styled-components';

export const Container = styled.nav`
  width: 100%;
  background-color: #e5e5e5;
  padding: 20px 30px;

  .nav-link {
    color: #666666;
    display: flex;
    align-items: center;
    justify-content: center;
    position: relative;
    overflow: visible;
    font-weight: 400;
    border-radius: 6px 6px 0 0;

    .tab-close {
      position: absolute;
      top: -8px;
      right: -6px;
      z-index: 3;
      pointer-events: auto;
      display: inline-flex;
    }

    .tab-close__btn {
      background-color: ${({ theme: { colors } }) => colors.danger};
      border: none;
      color: ${({ theme: { colors } }) => colors.white};
      border-radius: 50%;
      width: 20px;
      height: 20px;
      display: inline-flex;
      justify-content: center;
      align-items: center;
      box-shadow: 0 2px 6px rgba(0, 0, 0, 0.2);
      opacity: 0;
      transition: opacity 0.2s ease-in-out;

      svg {
        font-size: 12px;
      }

      &:focus {
        outline: 2px solid ${({ theme }) => lighten(0.35, theme.colors.danger)};
        outline-offset: 2px;
      }
    }

    &:hover .tab-close__btn,
    &.active .tab-close__btn {
      opacity: 1;
    }

    &:hover {
      background-color: ${({ theme: { colors } }) =>
        lighten(0.75, colors.primary)};
    }

    &.active {
      color: ${({ theme }) => theme.colors.primary};
      font-weight: 600;
      background-color: ${({ theme }) => theme.colors.white};
      left: -1px;
    }

    &.activeHome {
      font-size: 20px;
    }
  }

  .tab-content {
    background-color: ${({ theme }) => theme.colors.white};
    border-radius: 0 6px 6px 6px;
  }
`;

export const CloseButton = styled.button`
  width: 15px;
  height: 15px;
  position: relative;
  left: -15px;
  top: -10px;
  border-radius: 50%;
  border: 1px solid transparent;
  color: #f44444;
  background-color: #fff;
  opacity: 0;
  animation: opacity 1s linear;
  box-shadow: 2px 2px 1px rgba(0, 0, 0, 0.5);
  display: flex;
  justify-content: center;
  align-items: center;

  &:hover {
    opacity: 1;
  }
`;
